import tippy from 'tippy.js';

tippy('.js-tooltip', {
  content: (reference) => document.querySelector(reference.getAttribute('data-target')).innerHTML,
  allowHTML: true,
  interactive: true,
  maxWidth: '',
});
